import { memo } from "react";
import isNumber from "lodash/isNumber";

import { clsxMerge, pluralizeNoun } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

interface CharacterLimitCounterPropsI extends PropsWithClassNameI {
  contentLength?: number;
  maxLength?: number;
}

export const CharacterLimitCounter = memo(
  ({ className, contentLength, maxLength }: CharacterLimitCounterPropsI) => {
    if (!(isNumber(contentLength) && contentLength >= 0 && maxLength)) {
      return null;
    }

    const remainingCharacters = maxLength - (contentLength || 0);

    return (
      <div className={clsxMerge("mb-2 mt-1 text-left text-xs", className)}>
        {remainingCharacters} {pluralizeNoun("character", remainingCharacters)}{" "}
        remaining
      </div>
    );
  }
);

CharacterLimitCounter.displayName = "CharacterLimitCounter";
